export const Endpoints = Object.freeze({
    api: {
        version: "v1",
        host: "api"
    },

    LOGIN: "auth/login",
    OTP: "auth/otp",
    XSRF: "auth/xsrf",

    USER: (id = "@me") => {
        return "v1/users/" + id;
    },
    USERS: "v1/users",
    WEBPUSH: "v1/users/@me/webpush",
    CHANGE_USER: "v1/users/@me",
    CHANGE_USER_PERMISSIONS: (id = "@me") => {
        return "v1/users/" + id + "/permissions";
    },
    TEST_USER_NOTIFIACIOTNS: (id = "@me") => {
        return "v1/users/" + id + "/notifications";
    },
    CHANGE_USER_PREF: "v1/users/@me/preferences",

    ORDERS: "v1/orders",
    ORDERS_BY_ID: (id) => {
        return "v1/orders/" + id
    },
    FINISH_CALL_ORDER: (id) => {
        return "v1/orders/" + id + "/called"
    },
    FINISH_ORDER: (id) => {
        return "v1/orders/" + id + "/finish"
    },
    ORDERS_USERS: (orderID, userID = "@me") => {
        return "v1/orders/" + orderID + "/users/" + userID
    },

    RESTAURANTS: "v1/restaurants",
    RESTAURANT: (id) => {
        return "v1/restaurants/" + id
    },
})
